import { render, staticRenderFns } from "./aggregates_info.vue?vue&type=template&id=0c8aeb88&scoped=true&"
import script from "./aggregates_info.vue?vue&type=script&lang=js&"
export * from "./aggregates_info.vue?vue&type=script&lang=js&"
import style0 from "./aggregates_info.vue?vue&type=style&index=0&id=0c8aeb88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8aeb88",
  null
  
)

export default component.exports